export default __webpack_public_path__ + "f416f1a1fc0afcb112fa4be2b265fc01.png";